import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StyledMapWithAnInfoBox from './GoogleMap/StyledMapWithAnInfoBox';
import DetailedStyledMapWithAnInfoBox from './GoogleMap/DetailedStyledMapWithAnInfoBox';
import { setGeoLocation } from '../Actions/GoogleMap.action';
import { translate } from '../Services/translation';
import { useLoadScript } from "@react-google-maps/api";
import LoaderBlockContent from './LoaderBlockContent';

const GOOGLE_MAPS_API_KEY = "AIzaSyBxYLDy8IZe-4HW-MFQJJStXFJX8i7q7cI";
const MAP_LIBRARIES = ["geometry", "drawing", "places"];

const ResellerMap = () => {
  const dispatch = useDispatch(),
    { isDetailedView, resellers } = useSelector((state) => state.googleMap);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: MAP_LIBRARIES,
  });

  if (!isLoaded) return <div><LoaderBlockContent /></div>;

  const onToggleOpen = (value) => {
    const selectedItemIndex = value.split('_');
    const selectedLocation = resellers[selectedItemIndex[0]].resellerItems[selectedItemIndex[1]];
    dispatch(setGeoLocation(selectedLocation));
  };

  return (
    <Fragment>
      {isDetailedView ? <DetailedStyledMapWithAnInfoBox /> : <StyledMapWithAnInfoBox />}
      <div className="resellers">
        <div className="resellers__row">
          {resellers && resellers.map((reseller, resellerIndex) => (
            <div className="resellers__repeat" key={resellerIndex}>
              <div className="resellers__address">
                <details>
                  <summary className="resellers__title">
                    <span className="resellers__title__name">{reseller.name}</span>{' '}
                    <span className="resellers__title__length">{reseller.resellerItems.length}</span>
                  </summary>
                  <code className="details-wrap">
                    <div className="reseller-row">
                      {reseller.resellerItems.map((resellerItem, resellerItemIndex) => (
                        <div className="resellers__details" key={`${resellerIndex}_${resellerItemIndex}`}>
                          <h2>{resellerItem.agentName}</h2>
                          <p>{resellerItem.address}</p>
                          <p>
                            <a href={`tel:${resellerItem.phone}`}>
                              {translate('resellermap.phone')} : {resellerItem.phone}
                            </a>
                          </p>
                          <p>
                            <a href={`mailto:${resellerItem.email}`}>{resellerItem.email}</a>
                          </p>
                          {resellerItem.resellerWebsiteUrl && resellerItem.resellerWebsiteUrl.length > 0 && (
                            <p>
                              <a href={resellerItem.resellerWebsiteUrl} target="_blank">
                                {resellerItem.resellerWebsiteUrl}
                              </a>
                            </p>
                          )}
                          <p>
                            <span className="show-map" onClick={() => onToggleOpen(`${resellerIndex}_${resellerItemIndex}`)}>
                              {translate('resellermap.showmap')}
                            </span>
                          </p>
                        </div>
                      ))}
                    </div>
                  </code>
                </details>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="reseller-clear"></div>
    </Fragment>
  );
};

export default ResellerMap;
